import { useQuery } from '@tanstack/react-query';
import Axios, { AxiosRequestConfig } from 'axios';

import type { ScenarioGlobalProperty } from './useScenarioGlobalProperties';

export type ScenarioGlobalPropertyValue =
  | Record<
      string,
      | string
      | number
      | boolean
      | null
      | {
          type: string;
          value: string | number | boolean | null;
        }
    >
  | string[];

export interface ScenarioGlobalPropertyWithValue extends ScenarioGlobalProperty {
  value: ScenarioGlobalPropertyValue;
}

const SCENARIO_GLOBAL_PROPERTIES_URL = '/v1/scenario_global_properties';

export const fetchScenarioGlobalProperty = async (globalPropertyId: string, config?: AxiosRequestConfig) => {
  const { data } = await Axios.get<ScenarioGlobalPropertyWithValue>(
    `${SCENARIO_GLOBAL_PROPERTIES_URL}/${globalPropertyId}`,
    config
  );

  return data;
};

export const useScenarioGlobalProperty = (
  globalPropertyId?: string,
  config?: { enabled?: boolean; staleTime?: number },
  requestConfig?: AxiosRequestConfig
) =>
  useQuery<ScenarioGlobalPropertyWithValue>({
    queryKey: [SCENARIO_GLOBAL_PROPERTIES_URL, globalPropertyId],
    queryFn: () => fetchScenarioGlobalProperty(globalPropertyId as string, requestConfig),
    enabled: !!globalPropertyId,
    ...config
  });
